import React from "react";
import { makeIconDef } from "./makeIconDef";
export var CircleIconDef = {
    circle: makeIconDef('circle', {
        regular: function () { return React.createElement("circle", { cx: "12", cy: "12", r: "8.5", stroke: "currentColor" }); },
        filled: function () { return React.createElement("circle", { cx: "12", cy: "12", r: "9", fill: "currentColor" }); },
    })
};
